var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6658 14.2148L15.567 17.0371H12.6256L13.5098 14.2148C13.7139 13.5348 13.8838 12.7357 14.0537 12.0726H14.0877C14.2578 12.7358 14.4447 13.5178 14.6658 14.2148ZM28 8.00002V24C28 26.2 26.2 28 24 28H8.00002C5.8 28 4 26.2 4 24V8.00002C4 5.8 5.8 4 8.00002 4H24C26.2 4 28 5.8 28 8.00002ZM19.2053 21.8654L15.4818 10.4066H12.8127L9.14041 21.8654H11.2996L12.2858 18.6182H15.9241L16.9612 21.8654H19.2053ZM22.7407 13.5858H20.6324V21.8654H22.7407V13.5858ZM22.8596 11.2736C22.8426 10.6276 22.4006 10.1346 21.6865 10.1346C20.9894 10.1346 20.5135 10.6276 20.5135 11.2736C20.5135 11.9028 20.9724 12.3957 21.6695 12.3957C22.4006 12.3957 22.8596 11.9027 22.8596 11.2736Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrator);
export default __webpack_public_path__ + "static/media/illustrator.81b52af26643ab189cfc18c3b40b71d5.svg";
export { ForwardRef as ReactComponent };